import React, {Component} from 'react';
import {Image, Container, Header, Grid, Popup,Icon, Menu} from "semantic-ui-react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Sponsors1 from '../assets/drive-download-20210121T173126Z-001/sponsors1.png'
import Realme from '../assets/images/sponsors/2020/realme.png'
import Gail from '../assets/images/sponsors/2020/gail.jpg'
import Gaana from '../assets/images/sponsors/2020/gaana_social.png'
import Azure from '../assets/images/sponsors/2020/azure.jpg'
import Honywell from '../assets/images/sponsors/2020/honywell.jpg'
import SBI from '../assets/images/sponsors/2020/sbi.png'
import Canara from '../assets/images/sponsors/2020/canara.png'
import TS_Dairy from '../assets/images/sponsors/2020/ts.png'
import Talent_sprint from '../assets/images/sponsors/2020/talentsprint.jpg'
import Falcon_pumps from '../assets/images/sponsors/2020/falcon.png'
import LIC from '../assets/images/sponsors/2020/lic.png'
import NTPC from '../assets/images/sponsors/2020/ntpc.png'
import Tinder from '../assets/images/sponsors/2020/tinder.png'
import Harbour_technologies from '../assets/images/sponsors/2020/harbour.png'
import Refuel_Merchant from '../assets/images/sponsors/2020/refuel.jpg'
import Jersey_Recharge from '../assets/images/sponsors/2020/Event_sponsor.png'
import London_Bubble_Co from '../assets/images/sponsors/2020/london.jpg'
import Verzeo from '../assets/images/sponsors/2020/verzeo.jpg'
import OLA from '../assets/images/sponsors/2020/ola.png'
import CENTRO from '../assets/images/sponsors/2020/centro.png'
import Awesong from '../assets/images/sponsors/2020/awesong.png'
import Veels from '../assets/images/sponsors/2020/veelson.png'
import Solitaire from '../assets/images/sponsors/2020/solitaire.png'
import Loacker from '../assets/images/sponsors/2020/loacker.jpg'
import Career from '../assets/images/sponsors/2020/hbrascend.jpeg'
import IFP from '../assets/images/sponsors/2020/ifp.jpg'
import Portronics from '../assets/images/sponsors/2020/Portronics.jpg'
import Hy_Dance from '../assets/images/sponsors/2020/hy.png'
import Safe_Express from '../assets/images/sponsors/2020/safexpress.png'
import ATKT from '../assets/images/sponsors/2020/atkt_resized.png'
import Hidden_Hour from '../assets/images/sponsors/2020/hidden-hour.jpg'
import Ski_capital from '../assets/images/sponsors/2020/ski.png'
import BYKO_journeys from '../assets/images/sponsors/2020/byko_resized.jpeg'
import Grab_On from '../assets/images/sponsors/2020/grab.jpg'
import VishuMoney from '../assets/images/sponsors/2020/vish.png'
import Wiley from '../assets/images/sponsors/2020/wiley.jpeg'
import Coding_Blocks from '../assets/images/sponsors/2020/codingblocks.jpg'
import Event_Beep from '../assets/images/sponsors/2020/eventbeep.png'
import Hyderabad_Komedy_Klub from '../assets/images/sponsors/2020/komedy.jpg'
import Telangana_Today from '../assets/images/sponsors/2020/tt.png'
import Women_Era from '../assets/images/sponsors/2020/woman.png'
import DU_Beat from '../assets/images/sponsors/2021/DUBeat.jpg'
import DE_DU_Express from '../assets/images/sponsors/2020/duexpress.png'
import Big_FM from '../assets/images/sponsors/2020/big.png'
import Shubhang_Communications from '../assets/images/sponsors/2020/shubang.jpg'
import Youth_incorporated from '../assets/images/sponsors/2020/Yi_New_Logo.png'
import technology_for_you from '../assets/images/sponsors/2020/techforyou.jpg'
import Brainfeed from '../assets/images/sponsors/2020/brainfeed.jpeg'
import Bada_business from '../assets/images/sponsors/2020/bada-business.png'
import WAC from '../assets/images/sponsors/2020/wac.jpeg'
import Robo_Qube from '../assets/images/sponsors/2020/roboqube.png'
import The_Souled_Store from '../assets/images/sponsors/2020/souled.png'
import Elan from '../assets/images/logos/elan-col.png'
import '../assets/styles/sponsors.scss';
import Logo from "../assets/images/logos/elan-row.png";
import {Nav, NavLink, Bars, NavMenu, Cross} from "../layout/NavbarElements";
import LnT from '../assets/images/sponsors/2021/L&T.jpg'
import Arcesium from '../assets/images/sponsors/2021/Arcesium.png'
import Union from '../assets/images/sponsors/2021/unionb.png'
import Foxmula from '../assets/images/sponsors/2021/Foxmula.png'
import Knowello from '../assets/images/sponsors/2021/knowello.png'
import Yocket from '../assets/images/sponsors/2021/yocket.png'
import Celeb8 from '../assets/images/sponsors/2021/celebr8.jpg'
import Fanclash from '../assets/images/sponsors/2021/fanclash.png'
import CodingNinjas from '../assets/images/sponsors/2021/CodingNinjas.png'
import chromatics from '../assets/images/sponsors/2021/chromatics.png'
import coolwinks from '../assets/images/sponsors/2021/coolwinks.jpg'
import TalkingTimber from '../assets/images/sponsors/2021/TalkingTimber.jpg'
import skolar from '../assets/images/sponsors/2021/Skolar.jpg'
import FASHION_HERALD from '../assets/images/sponsors/2021/FASHION_HERALD.png'
import Indinoir from '../assets/images/sponsors/2021/Indinoir.png'
import internshala from '../assets/images/sponsors/2021/internshala.png'
import Noticebard from '../assets/images/sponsors/2021/Noticebard.png'
import Summachar from '../assets/images/sponsors/2021/summachar.png'
import Esports from '../assets/images/sponsors/2021/Esports.png'
import CanaraBank from '../assets/images/sponsors/2021/CanaraBank.png'
import QT from '../assets/images/sponsors/2021/QT.png'
import vishumoney from '../assets/images/sponsors/2021/vishumoney.jpeg'
import Kaploths from '../assets/images/sponsors/2021/Kaploths.jpg'
import ces from '../assets/images/sponsors/2021/ces.png'
import CampusComedyClub from '../assets/images/sponsors/2021/CampusComedyClub.png'
import Vedana from '../assets/images/sponsors/2021/Vedana.png'
import CelebritySchool from '../assets/images/sponsors/2021/CelebritySchool.png'
import GrabOn from '../assets/images/sponsors/2021/GrabOn.png'
import AM from '../assets/images/sponsors/2021/AM.png'
import FORE from '../assets/images/sponsors/2021/FORE.png'
import Eleation from '../assets/images/sponsors/2021/Eleation.jpeg'
import Techienest from '../assets/images/sponsors/2021/techienest.png'
import CodeforCause from '../assets/images/sponsors/2021/CodeforCause.png'
import Shubhang from '../assets/images/sponsors/2021/Shubang.jpg';
import HansIndia from '../assets/images/sponsors/2021/hansindia.jpg';




class Sponsors extends Component {

  state = {
    sidebarOpened: false,
    currentYear:2021,
  };

  toggleSidebar = () =>
      this.setState({ sidebarOpened: !this.state.sidebarOpened });
  closeSidebar = () => this.setState({ sidebarOpened: false });

  render() {
    return (
        <>
          <div
              id={"navbar"}
              className={`navbar-container sponsors-page`}
          >
            <Nav>
              <NavLink onClick={this.closeSidebar} className={"logo-link"} to="/">
                <img src={Logo} className={"navbar-logo"} alt="logo" />
              </NavLink>
              {this.state.sidebarOpened ? <Cross
                  className={`toggle-btn ${this.state.sidebarOpened ? "active" : ""}`}
                  //style={{display:`${this.state.sidebarOpened ? 'block' : 'none'}`}}
                  onClick={this.toggleSidebar}
              /> : <Bars
                  className={`toggle-btn ${this.state.sidebarOpened ? "active" : ""}`}
                  //style={{display:`${this.state.sidebarOpened ? 'none' :'block' }`}}
                  onClick={this.toggleSidebar}
              />}

              <NavMenu
                  className={`nav-menu ${this.state.sidebarOpened ? "active" : ""}`}
              >
                <a onClick={()=>{
                  this.setState({currentYear:2021})
                }} className={'external-link'}>
                  2021
                </a>
                <a onClick={()=>{
                  this.setState({currentYear:2020})
                }} className={'external-link'}>
                  2020
                </a>
                {/*<a onClick={()=>{
                  this.setState({currentYear:2019})
                }} className={'external-link'}>
                  2019
              </a>
                <a onClick={()=>{
                  this.setState({currentYear:2018})
                }} className={'external-link'}>
                  2018
                </a>*/}
                {/* Second Nav */}
                {/* <NavBtnLink to='/sign-in'>Sign In</NavBtnLink> */}
              </NavMenu>

            </Nav>
          </div>
            {/*<div className='' style={{backgroundColor:'#f7e986', height:'100vh', paddingTop:'8%'}}>
                <Container style={{backgroundColor:'white',width:'25%',
                        position:'relative',borderRadius:'0px 150px 150px 150px', position:'center', marginBottom:'2%'}}>
                    <Header style={{color:'#FF3F1A',fontSize:'2em.5em',fontFamily:'\'Paytone One\', sans-serif', textAlign:'center', padddingTop:'1%', paddingBottom:'1%'}}>
                        OUR SPONSORS
                    </Header>
                </Container>
                <Carousel
                    swipeable={false}
                    draggable={false}
                    showDots={true}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={this.props.deviceType !== "mobile" ? true : false}
                    autoPlaySpeed={1000}
                    keyBoardControl={true}
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    deviceType={this.props.deviceType}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                    >
                    <img src="http://www.fillmurray.com/400/300"/>
                    <img src="http://www.fillmurray.com/400/300" />
                    <img src="http://www.fillmurray.com/400/300" />
                    <img src="http://www.fillmurray.com/400/300" />
                    <img src="http://www.fillmurray.com/400/300" />
                    <img src="http://www.fillmurray.com/400/300" />
                    <img src="http://www.fillmurray.com/400/300" />
                </Carousel>;
                <Image size={'medium'} src={Sponsors1} size={'large'} style={{position:'absolute', bottom:'0'}}/>
            </div>*/}

          {this.state.currentYear === 2020 ?
              (<div className={'Heading'} style={{backgroundColor:'#cbfff8'}}>
              

              <Grid stackable style={{paddingRight:'10%', paddingLeft:'10%'}}>

                <Grid.Row columns={1}>
                  <Image src={Elan} size={'huge'} centered style={{marginTop: '-15%'}}/>
                </Grid.Row>

                <Container style={{backgroundColor:'white',width:'25%',
                        position:'relative',borderRadius:'0px 150px 150px 150px', marginBottom:'15%'}}>
                    <Header style={{color:'#FF3F1A',fontSize:'2.5em',fontFamily:'\'Paytone One\', sans-serif', textAlign:'center', padddingTop:'1%', paddingBottom:'1%'}}>
                        OUR SPONSORS
                    </Header>
              </Container>

                <Grid.Row columns={1} style={{paddingBottom:'4%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                        <Image size={'large'} src={Realme} centered/>
                        <p style={{textAlign:'center', fontSize:'2em', paddingTop:'2%'}}>Title Partner</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Realme</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%',   paddingRight:'15%', paddingLeft:'15%'}}>Realme is a Chinese smartphone manufacturer headquartered in Beijing.Realme also produces a wide variety of other products such as earphones, wireless earphones, T-shirts, bags, fitness bands, smartwatches, etc.</p>
                      <Menu.Item href='https://www.facebook.com/realmeIndia'>
                        <Icon name='facebook square' size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/realmeindia/'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/realmecareIN'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://www.realme.com/in/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={1}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                        <Image size={'medium'} src={Gail} centered />
                        <p style={{textAlign:'center', fontSize:'2em', paddingTop:'2%'}}>Platinum Sponsor</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Gail</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>Gail (India) Limited (formerly known as Gas Authority of India Ltd.) is Government of India undertaking company. Gail is the largest state-owned natural gas processing and distribution company in India.</p>
                      <Menu.Item href='https://www.facebook.com/GAILIndia/'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/gailindia/?hl=en'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/gailindia'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://gailonline.com/home.html">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={1} style={{paddingBottom:'2%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                        <Image size={'large'} src={Gaana} centered />
                        <p style={{textAlign:'center', fontSize:'2em'}}>Music Partner</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Gaana</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>Gaana is India's largest commercial music streaming service with over 150 million monthly users. The entire Indian music catalog is available to users worldwide. Gaana.com features music from 21 languages</p>
                      <Menu.Item href='https://www.facebook.com/gaana.com'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/gaana/?hl=en'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/gaana'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://gaana.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{paddingTop:'10%', paddingBottom:'8%'}}>
                  
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                  <Popup
                      trigger={
                      <div>
                        {<Image size={'medium'} src={Azure} centered/>}
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Workshop Partner</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Azure Skynet</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>Azure Skynet is an ISO 9001:2015 certified training and service provider company which deals in imparting superior quality of training on various technologies from different domains of IT industry.</p>
                      <Menu.Item href='https://www.facebook.com/azureskynet/'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/azureskynet/?igshid=17d9km8a0bqhq&hl=en'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/azureskynet'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://www.azureskynet.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                        <Image size={'medium'} src={Honywell} centered/>
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Sustainable Future Partner</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Honeywell</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                        Honeywell International Inc. is a technology and manufacturing company. The Company operates through four segments: Aerospace, Home and Building Technologies, Performance Materials and Technologies, and Safety and Productivity Solutions.</p>
                      <Menu.Item href='https://www.facebook.com/Honeywell/'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/honeywell'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/honeywell'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://www.honeywell.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                        <Image size={'medium'} src={SBI} centered/>
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gold Sponsor</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>SBI</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      State Bank of India is an Indian multinational, public sector banking and financial services statutory body.SBI provides a range of banking products through its network of branches in India and overseas</p>
                      <Menu.Item href='https://www.facebook.com/StateBankOfIndia'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/theofficialsbi'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/TheOfficialSBI'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://onlinesbi.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                  </Grid.Column>

                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'8%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                        <Image size={'medium'} src={Canara} centered/>
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gold Sponsor</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Canara Bank</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Canara Bank Limited is one of the largest public sector banks owned by the Government of India.Canara Bank occupies a premier position in the comity of Indian banks with an unbroken record of profits since its inception.</p>
                      <Menu.Item href='https://www.facebook.com/canarabank'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/canarabankinsta'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/canarabank'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://www.canarabank.com/english/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                        <Image size={'medium'} src={Solitaire} centered />
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Fitness Partner</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Solitaire fitness</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Solitaire Fitness Pro, is registered Trade Mark of Solitaire International Co based out of Hyderabad. Their centres are established with the most modern and scientifically built equipment, well trained trainers and world class ambiance.</p>
                      <Menu.Item href='https://www.facebook.com/solitairefitness'>
                        <Icon name='facebook square' size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/solitairefitness'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      <Menu.Item href="https://solitairefitness.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                      trigger={
                      <div>
                      <Image size={'medium'} src={TS_Dairy} centered />
                        <p style={{textAlign:'center', fontSize:'1.5em'}}>TS Dairy</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Vijaya Telangana</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Vijay Dairy has a committed vision to procure quality milk from the farmers and produce milk and milk products through superior technology and process and makes it available to customers at competitive price.</p>
                      <Menu.Item href='https://www.facebook.com/vijayadairyT'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/vijayadairytg/?hl=en'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/dairy_vijaya?lang=en'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="http://tsdairy.telangana.gov.in/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                    
                    <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                      trigger={
                      <div>
                      <Image size={'medium'} src={Talent_sprint} centered />
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>AI Sponsor</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Talent sprint</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      TalentSprint brings high-end and deep-tech education to aspiring and experienced professionals. Thier hybrid platform delivers unique onsite and online experiences that help build cutting-edge expertise.</p>
                      <Menu.Item href='https://www.facebook.com/talentsprint/'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/talentsprint_edu/?hl=en'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/talentsprint?lang=en'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://talentsprint.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>

                    </Grid.Column>
                    <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                      trigger={
                      <div>
                      <Image size={'medium'} src={Falcon_pumps} centered />
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Platinum Partner</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Falcon pumps</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Falcon Pumps Pvt. Ltd. is a leading manufacturer of world-class pumping solutions providing technically most advanced, excellent energy efficient and lifelong durable pumping equipments across the globe.</p>
                      <Menu.Item href='https://www.facebook.com/falconpump/'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/falconpumps2019/?igshid=18qyseeym0031'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      <Menu.Item href="https://www.falconpumps.in/index.php">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                    </Grid.Column>

                    <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                      trigger={
                      <div>
                      <Image size={'medium'} src={Realme} centered />
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Official Smartphone Sponsor</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>RealMe</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Realme is a Chinese smartphone manufacturer headquartered in Beijing.Realme also produces a wide = 'very' variety of other products such as earphones, wireless earphones, T-shirts, bags, fitness bands, smartwatches, etc.</p>
                      <Menu.Item href='https://www.facebook.com/realmeIndia'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/realmeindia/'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/realmecareIN'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://www.realme.com/in/'>
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                    </Grid.Column>
                    
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                      trigger={
                      <div>
                      <Image size={'medium'} src={LIC} centered />
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Major Sponsor</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>LIC</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Life Insurance Corporation of India (abbreviated as LIC) is an Indian state-owned insurance group and investment corporation owned by the Government of India. Over 245 insurance companies and provident societies were merged to create the state-owned Life Insurance Corporation of India.</p>
                      <Menu.Item href='https://www.facebook.com/LICIndiaForever'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/licindiaforever/?hl=en'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/LICIndiaForever'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="http://www.licindia.in/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                    </Grid.Column>
                    <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                      trigger={
                      <div>
                      <Image size={'medium'} src={NTPC} centered  />
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Major Sponsor</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>NTPC</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      NTPC Limited, formerly known as National Thermal Power Corporation Limited, is an Indian Public Sector Undertaking, engaged in the business of generation of electricity and allied activities.</p>
                      <Menu.Item href='https://www.facebook.com/ntpc1/'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/ntpclimited/'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/ntpclimited'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://www.ntpc.co.in/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                    </Grid.Column>
                    <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                      trigger={
                      <div>
                      <Image size={'medium'} src={Tinder}centered />
                        <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Tinder Sponsor</p>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Tinder</Popup.Header>
                    <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Tinder is an American geosocial networking and online dating application that allows users to anonymously swipe to like or dislike other profiles based on their photos, a small bio, and common interests.</p>
                      <Menu.Item href='https://www.facebook.com/TinderInd'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/tinder_india'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/Tinder_India'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://tinder.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>
                    </Popup>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Harbour_technologies} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Workshop Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Harbour technologies</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Harbour Technologies is a company by Engineers and a leading provider of end to end workshop and education solutions, covering various emerging technologies in India. They are trusted service brands in the field of latest technologies.</p>
                    <Menu.Item href='https://www.facebook.com/harbourtech'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="https://www.harbourtech.co.in/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Refuel_Merchant} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>F&B Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Refuel Merchant</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Refuel Merchant is a leading distributor and supplier of Lubricant Oil and Castrol Oil. Refuel Merchant is listed in Trade India's verified sellers offering supreme quality.</p>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Jersey_Recharge} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Event Sponsor</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Jersey Recharge</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Creamline Dairy Products Limited (CDPL) is a leading Private Dairy player in Southern India. Its products are sold under the brand name `Jersey’. Since inception in 1986, the company has been growing consistently.</p>
                    <Menu.Item href='https://www.facebook.com/GodrejJersey/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/godrejjersey/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/godrejjersey'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="http://www.creamlinedairy.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                  
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={London_Bubble_Co} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Waffle Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>London Bubble Co.</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    London Bubble Company is a famous enterprise known for its waffles. They bring to you a variety of things which might delight your Sugar Tooth. They have come up with options of healthy waffles, dairy free milkshakes, New & better chocolate and waffles</p>
                    <Menu.Item href='https://www.facebook.com/LondonBubbleCo'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F71422031%2Fadmin'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="https://londonbubbleco.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Loacker} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Foodathon Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Loacker</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Since 1925, the name Loacker has stood for pure and wholesome natural goodness, the highest quality and love for nature - combined in their delicious wafer and chocolate specialities. They are known for their amazing line of chocolate products and wafers.</p>
                    <Menu.Item href='https://www.facebook.com/Loacker/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/loacker/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="https://www.loacker.com/int/en/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Verzeo} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Official Internship Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Verzeo</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Verzeo is a pioneer in the Ed-Tech industry, the fastest-growing professional training platform in the country. As part of their initiative for educating the upcoming generations to be producers of technology, they provide top-class internship and certification programs</p>
                    <Menu.Item href='https://www.facebook.com/verzeo.leadanywhere/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/verzeo/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/verzeo1?lang=en'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.verzeo.in/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={OLA} centered  />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Travel Sponsor</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>OLA</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={CENTRO} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Fashion Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>CENTRO</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    With the vision to deliver unparalleled and quality fashion footwear, to adorn feet across the country, CENTRO, within a decade of its inception, has established itself as one of the largest retail, distribution, and franchising companies in South India.</p>
                    <Menu.Item href='https://www.facebook.com/centroshoes/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/centroshoesindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/centro_shoes'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.fashioncentro.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Awesong} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Event Sponsor</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Awesong</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Veels} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Event Sponsor</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Veels on 5er</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Veels on 5er are committed to satisfy all your hobby needs. They help you get into the hobby by providing all the details/information you would ever require.
                              They provide complete sales & service for any brand/model RC Nitro Cars, Electric Cars</p>
                    <Menu.Item href='https://www.facebook.com/VeelsOn5er/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="https://www.veelson5er.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Career} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Career Growth Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Ascend</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ascend from Harvard Business Review is a digital learning companion for millennials and graduating students, focused on developing soft-skills which can provide an extra edge for balanced career growth.</p>
                    <Menu.Item href='https://www.facebook.com/hbrascend/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/hbrascend/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/hbrascend?lang=en'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://hbrascend.org/home/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={IFP} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Event Sponsor</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>India Film Project</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    India Film Project, since its birth in 2011, has been putting in efforts to build a community of content creators across the varying forms of art. The 50-hour filmmaking challenge is IFP’s cornerstone. Now IFP also extended itself in other forms of art, mainly writing, designing, music and storytelling</p>
                    <Menu.Item href='https://www.facebook.com/indiafilmproject'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/indiafilmproject'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/ifilmproject'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://indiafilmproject.co/campus/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Portronics} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gadgets Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Portronics</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Since its inception in 2010, Portronics has been a pioneer in Portable & Innovative technology. A leader in the Consumer Electronics space, Portronics has launched over 1,600 products since its inception and continues to make access to innovation, easier. They believe that a product is more than just a gadget; its a lifestyle experience!</p>
                    <Menu.Item href='https://www.facebook.com/portronics.india'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://instagram.com/portronics.india'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/portronics'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.portronics.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Hy_Dance} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Event Sponsor</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Hy Dance Studios</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Hy dance studio believes that nobody has two left feet. Every living being feels music and it moves the soul. They are known for being the guides in creating an expression for what you feel, how you feel and with how much intensity, in the form of dancing.</p>
                    <Menu.Item href='http://fb.com/hydance.in'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='http://instagr.am/hydance.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="https://www.hydance.in/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Safe_Express} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Official Supply Chain Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Safe Express</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Safexpress began its journey in 1997 with a mission of delivering logistics excellence to its customers and ensuring their success. Today, the firm has firmly entrenched itself as the 'Knowledge Leader' and 'Market Leader' of supply chain & logistics industry in India.</p>
                    <Menu.Item href='https://www.facebook.com/SafexpressPrivateLimited/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/safexpress/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Safexpress?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="http://www.safexpress.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>
 
                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={ATKT} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'2%'}}>Content Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>ATKT</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    ATKT.in is India's first nation-wide community for, by, and of culturally talented youth. ATKT provides a platform for college-level artists and creators across the fields of performing arts like singing, dancing, slam poetry, and comedy. </p>
                    <Menu.Item href='https://www.facebook.com/pg/ATKT.in/about/?ref=page_internal'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://instagram.com/atktin/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/atktin'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://atkt.in/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Hidden_Hour} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Escape Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>The Hidden Hour</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    The Hidden Hour is India’s No. 1 Escape room company that offers both play at center and play at home/office games. If you are an adventure game lover and looking for a thrilling games full of suspense and entertainment, then The Hidden Hour games is the best option.Tripadvisor and Google has ranked them as the Top Gaming Attraction in India.</p>
                    <Menu.Item href='https://www.facebook.com/TheHiddenHour/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/thehiddenhour/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/the_hiddenhour?lang=en'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://www.thehiddenhour.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Ski_capital} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Fun Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Ski Capital</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      SKI Capital Services Limited (SKI) is an established & premier financial and stock broking house with a vision to offer various financial services and products in such a way that it leads to optimum gains for the entities involved in these transactions.</p>
                    <Menu.Item href='http://www.facebook.com/skicapital'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    <Menu.Item href='https://twitter.com/skicapitalltd'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={BYKO_journeys} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'2%'}}>Trip Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>BYKO journeys</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Byko Journeys primarily is an experiential travel company organizing fixed departure group trips for like-minded travelers. As India's fastest growing travel community, their pledge is to deliver a candid experience as you venture into the heart of wildlands rekindling the fire within.</p>
                    <Menu.Item href='https://www.facebook.com/pg/ATKT.in/about/?ref=page_internal'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://instagram.com/bykojourneys'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="https://www.bykojourneys.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Grab_On} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Savings Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Grab On</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      GrabOn is a trusted brand and a pioneer in affiliate e-commerce scene in India. They are known for maintaining high quality standards through their unique user interface and user experience. They are known for providing the most authentic and updated coupons and deals. Today, GrabOn is the top player in the coupons and deals industry.</p>
                    <Menu.Item href='https://www.facebook.com/grabon.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/grabonindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/GrabOnIn/'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://www.grabon.in/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={VishuMoney} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Discount Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>VishuMoney</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    VishUmoney is a diversified, online money-making and saving platform trying to make a huge difference by bringing a positive change in the world of online shopping and earning. VishUmoney provides online shopping from more than 2000 stores, saving while shopping, earning cashback, and earning money by performing some trivial tasks.</p>
                    <Menu.Item href='https://www.facebook.com/vishumoney/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/vish_u_money/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/vish_u_money'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.vishumoney.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Wiley} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'2%'}}>Knowledge Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Wiley</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    John Wiley & Sons, Inc., commonly known as Wiley, is an American multinational publishing company that  focuses on academic publishing and instructional materials.  The company produces training materials and educational materials for undergraduate, graduate, and continuing education students.</p>
                    <Menu.Item href='https://www.facebook.com/JohnWileySons/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    <Menu.Item href='https://twitter.com/wileyglobal?lang=en'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.wiley.com/en-us">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Coding_Blocks} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Coding Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Coding Blocks</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Coding Blocks was founded in 2014 with a mission to create skilled Software Engineers for our country and the world. Coding Blocks strives to increase student interest by providing hands on practical training on every concept taught in the classroom.</p>
                    <Menu.Item href='https://www.facebook.com/codingblocksindia'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/codingblocks/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/codingblocksIN'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://codingblocks.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Event_Beep} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Student Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Event Beep</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Event Beep is a platform for all the students to find all the event, activities & happenings in their cities, colleges based on their interests. With the vision of making college life eventful,Event Beep is a next generation community for students to connect, discover and reach their full potential.</p>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    <Menu.Item href='https://www.instagram.com/eventbeepindia/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="https://www.eventbeep.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Hyderabad_Komedy_Klub} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'2%'}}>Event Sponsor</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Hyderabad Komedy Klub</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Hyderabad Komedy Klub is an organisation which conducts stand up comedy events and other competitions in and around Hyderabad. </p>
                    <Menu.Item href='https://www.facebook.com/pages/category/Comedy-Club/Hyderabad-Komedy-Klub-299807777392582/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Telangana_Today} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Official Newspaper  Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Telangana Today</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Telangana Today is a registered English-language Indian daily newspaper headquartered in Hyderabad, Telangana, India. The pulication aims to focus mainly on politics and developments of the state of Telangana.</p>
                    <Menu.Item href='https://www.facebook.com/telanganatoday/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/telanganatoday/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/TelanganaToday'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://telanganatoday.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Women_Era} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Magazine Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Women's Era</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Woman's Era is an Indian fortnightly women interest magazine, published in English language. Woman's Era covers diverse topics including fashion, cookery, movie and book review, health, relationships, beauty, lifestyle, travel and technology, with comments on socialites and current events.</p>
                    <Menu.Item href='https://www.facebook.com/mobilemagzter'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/mobilemagzter/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/MobileMagzter'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://www.womansera.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={DU_Beat} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'2%'}}>Media Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>DU Beat</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Hyderabad Komedy Klub is an organisation which conducts stand up comedy events and other competitions in and around Hyderabad. </p>
                    <Menu.Item href='https://www.facebook.com/DelhiUniversityBeat'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/du_beat'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Tdu_beat'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://dubeat.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={DE_DU_Express} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Media Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>DE DU Express</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    DU Express is an independent student run online media platform based in Delhi University.It covers all the latest news and happenings in and around the campus. DU Express is an initiative to provide reliable information to students.</p>
                    <Menu.Item href='https://www.facebook.com/duexpress.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/duexpress/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/du_express?lang=en'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://duexpress.in/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Big_FM} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Radio Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>92.7 Big FM</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    92.7 Big FM is a national private FM radio station in India. It mainly plays music from local-language films along with occasional Western music.  It broadcasts primarily at 92.7 MHz from 58 stations across the country, reaching a potential audience of 450 million.</p>
                    <Menu.Item href='https://www.facebook.com/bigfmindia/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/bigfmindia/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/bigfmindia?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://www.bigfmindia.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Shubhang_Communications} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'2%'}}>Communications Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Shubhang Communications</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Shubang Communications is an integrated advertising, communications, new &media & publishing agency. It works with leading and emerging brands in the most demanding industry sectors, building value through Corporate Communications & Public Relations, Advertising, & New Media.</p>
                    <Menu.Item href='https://www.facebook.com/pages/category/Public-Relations-Agency/Shubang-Communications-Pvt-Ltd-1821387308122609/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                      <Menu.Item href='http://twitter.com/#!/JyothiGosala'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="http://www.shubangcommunications.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Youth_incorporated} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Youth Media Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Youth incorporated</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    The magazine showcases relevant information and articles on education in India and abroad. With campus reviews, student profiles, professor interviews and a strong focus on careers and entrepreneurship, the magazine aims to empower the youth in today’s competitive world. </p>
                    <Menu.Item href='https://www.facebook.com/youthincmag'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/youthincmag'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/youthincmag'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://youthincmag.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={technology_for_you} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Youth Media Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>technology for you</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Technology For You (TFY) Online Media is one of the leading online Tech News Media.They provide the Latest & Real-time news on Technology, Cyber Security, Smartphones/Gadgets, Apps, Startups, Careers, Tech Skills, Web Updates, TechKnowledge, Tech Product Reviews and COVID-19…etc.</p>
                    <Menu.Item href='https://www.facebook.com/brainfeededumag'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/brainfeedmagazine/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/brainfeedmagazn'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://brainfeedmagazin.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Brainfeed} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Magazine Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Brainfeed</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Brainfeed magazine is one of the pioneers in the field targeting the entire education sector from primary to high school education. It provides latest information on academic issues arising out of classroom pedagogical practices, innovative technology-based teaching and latest developments in the present educational scenario.</p>
                    <Menu.Item href='https://www.facebook.com/brainfeededumag'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/brainfeedmagazine/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/brainfeedmagazn'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://brainfeedmagazin.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Bada_business} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'2%'}}>Valued Sponsor</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Bada business</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Bada Business provides Extensive Knowledge of the Different Business Strategies and Frameworks, which will Help Indian SME’s to Do Big Business or Become Bada Business. Bada Business allows the user to learn 'Everything About Entrepreneurship', which is the World's Most Affordable Entrepreneurship Program</p>
                    <Menu.Item href='https://www.facebook.com/DailyMotivationByVivekBindra'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/vivek_bindra/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='http://twitter.com/DrVivekBindra'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://www.badabusiness.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={WAC} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Workshop Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>WAC</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    What After College helps students to enhance their skills, connect with experts and share their stories. Their aim is to help college students get access to best career counseling advice, training followed by mentoring by arranging career events across the country.</p>
                    <Menu.Item href='https://www.facebook.com/whataftercollege/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/what_after_college/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/letswac?lang=en#:~:text=What%20After%20College%20(%40letswac)%20%7C%20Twitter'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://whataftercollege.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'15%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Robo_Qube} centered  />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'2%'}}>Tech Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Robo Qube</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    RoboQube is a project-oriented educational initiative that sponsors local, regional and international robotic events for young students.It is designed to introduce Robotics to primary and secondary school children, as well as undergraduates.</p>
                    <Menu.Item href='https://www.facebook.com/RoboQubeindia/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="http://roboqube.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={The_Souled_Store} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Official Gifting Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>The Souled Store</Popup.Header>
                  <Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    The Souled Store creates and curates stunning designs and prints them on all sorts of equally stunning products like t-shirts, phone covers, backpacks, mugs and many more. </p>
                    <Menu.Item href='https://www.facebook.com/SouledStore'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/TheSouledStore/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/TheSouledStore'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                    <Menu.Item href="https://www.thesouledstore.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>
                  </Popup>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              <Grid stackable style={{paddingBottom:'15%', paddingRight:'10%', paddingLeft:'10%', paddingTop:'10%'}}>
              <Grid.Row columns={1} style={{paddingBottom:'5%'}}>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2.5em'}}>CONTACT US</p>
                    <hr style={{color:'black', width:'10%', marginTop:'-2%'}}></hr>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={1} style={{paddingBottom:'5%'}}>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Ashutosh Tiwari</p>
                    <p style={{fontSize:'1.35em'}}>70676 54276</p>
                    <p style={{fontSize:'1.35em'}}>ashutosh.t@elan.org.in</p>
                  </Grid.Column>
                </Grid.Row>
              <Grid.Row columns={4} style={{paddingBottom:'5%'}}>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                  <p style={{fontSize:'2em'}}>Aahan Jain</p>
                  <p style={{fontSize:'1.35em'}}>8008495801</p>
                  <p style={{fontSize:'1.35em'}}>aahan.j@elan.org.in</p>
                  </Grid.Column>

                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Chaitanya Varun</p>
                    <p style={{fontSize:'1.35em'}}>709507594</p>
                    <p style={{fontSize:'1.35em'}}>chaitanya.v@elan.org.in</p>
                  </Grid.Column>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Chirag Jain</p>
                    <p style={{fontSize:'1.35em'}}>9326168076</p>
                    <p style={{fontSize:'1.35em'}}>chirag.j@elan.org.in</p>
                  </Grid.Column>
                </Grid.Row>
              <Grid.Row columns={4}>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Prakhar Pragya</p>
                    <p style={{fontSize:'1.35em'}}>7549136119</p>
                    <p style={{fontSize:'1.35em'}}>prakhar.p@elan.org.in</p>
                  </Grid.Column>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Sachi Kavitake</p>
                    <p style={{fontSize:'1.35em'}}>9511631183</p>
                    <p style={{fontSize:'1.35em'}}>sachi.k@elan.org.in</p>
                  </Grid.Column>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Sohith Kumar</p>
                    <p style={{fontSize:'1.35em'}}>9511631183</p>
                    <p style={{fontSize:'1.35em'}}>sohith.k@elan.org.in</p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>) : null}




          {this.state.currentYear === 2021 ?
              (<div className={'Heading'} style={{backgroundColor:'#cbfff8'}}>
                <Grid stackable style={{paddingRight:'10%', paddingLeft:'10%'}}>

              <Grid.Row columns={1}>
                <Image src={Elan} size={'huge'} centered style={{marginTop: '-15%'}}/>
              </Grid.Row>
              <Container style={{backgroundColor:'white',width:'25%',
                      position:'relative',borderRadius:'0px 150px 150px 150px', marginBottom:'10%'}}>
                  <Header style={{color:'#FF3F1A',fontSize:'2.5em',fontFamily:'\'Paytone One\', sans-serif', textAlign:'center', padddingTop:'1%', paddingBottom:'1%'}}>
                      OUR SPONSORS
                  </Header>
            </Container>

            
              <Grid.Row columns={1} style={{paddingBottom:'10%'}}>
              <Container style={{width:'25%',
                        position:'relative',borderRadius:'0px 150px 150px 150px', marginBottom:'5%', marginTop:'10%'}}>
                    <Header style={{color:'#FF3F1A',fontSize:'2.5em',fontFamily:'\'Paytone One\', sans-serif', textAlign:'center', padddingTop:'1%', paddingBottom:'1%'}}>
                        Title Sponsor
                    </Header>
              </Container>
                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                  <Popup
                    trigger={
                    <div>
                      <Image size={'large'} src={LnT} centered/>
                      
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>L&T</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%',   paddingRight:'15%', paddingLeft:'15%'}}>Realme is a Chinese smartphone manufacturer headquartered in Beijing.Realme also produces a wide variety of other products such as earphones, wireless earphones, T-shirts, bags, fitness bands, smartwatches, etc.</p>
                    <Menu.Item href='https://www.facebook.com/realmeIndia'>
                      <Icon name='facebook square' size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/realmeindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/realmecareIN'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.realme.com/in/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                </Grid.Column>
              </Grid.Row>
              <Container style={{width:'35%',
                        position:'relative',borderRadius:'0px 150px 150px 150px', marginBottom:'2%', marginTop:'5%'}}>
                    <Header style={{color:'#FF3F1A',fontSize:'2.5em',fontFamily:'\'Paytone One\', sans-serif', textAlign:'center', padddingTop:'1%', paddingBottom:'1%'}}>
                        Technology Partner
                    </Header>
              </Container>
              <Grid.Row columns={1} style={{paddingBottom:'15%'}}>
                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                  <Popup
                    trigger={
                    <div>
                      <Image size={'large'} src={Arcesium} centered/>
                      
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Arcesium</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%',   paddingRight:'15%', paddingLeft:'15%'}}>Realme is a Chinese smartphone manufacturer headquartered in Beijing.Realme also produces a wide variety of other products such as earphones, wireless earphones, T-shirts, bags, fitness bands, smartwatches, etc.</p>
                    <Menu.Item href='https://www.facebook.com/realmeIndia'>
                      <Icon name='facebook square' size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/realmeindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/realmecareIN'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.realme.com/in/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                </Grid.Column>
              </Grid.Row>

                <Container style={{width:'25%',
                        position:'relative',borderRadius:'0px 150px 150px 150px', marginBottom:'5%', marginTop:'5%'}}>
                    <Header style={{color:'#FF3F1A',fontSize:'2.5em',fontFamily:'\'Paytone One\', sans-serif', textAlign:'center', padddingTop:'1%', paddingBottom:'1%'}}>
                        Major Sponsors
                    </Header>
              </Container>

              <Grid.Row columns={4} style={{marginBottom:'10%'}}>

              <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div >
                        <div style={{height:'150px'}}>
                        <Image src={Honywell} centered style={{paddingTop:'5%'}}/>
                        </div>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Honeywell</Popup.Header>
                   {/* <Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                        Honeywell International Inc. is a technology and manufacturing company. The Company operates through four segments: Aerospace, Home and Building Technologies, Performance Materials and Technologies, and Safety and Productivity Solutions.</p>
                      <Menu.Item href='https://www.facebook.com/Honeywell/'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/honeywell'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/honeywell'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://www.honeywell.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>*/}
                    </Popup>
                    <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Sustainable Future Partner</p>
                  </Grid.Column>
                  

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                        <div style={{height:'150px'}}>
                        <Image src={SBI} centered/>
                        </div>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>SBI</Popup.Header>
                    {/*<Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      State Bank of India is an Indian multinational, public sector banking and financial services statutory body.SBI provides a range of banking products through its network of branches in India and overseas</p>
                      <Menu.Item href='https://www.facebook.com/StateBankOfIndia'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/theofficialsbi'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/TheOfficialSBI'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://onlinesbi.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>*/}
                    </Popup>
                    <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gold Sponsor</p>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                      trigger={
                      <div>
                      <div style={{height:'150px'}}>
                      <Image src={CanaraBank} centered style={{paddingTop:'15%'}}/>
                      </div>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Canara Bank</Popup.Header>
                    {/*<Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Life Insurance Corporation of India (abbreviated as LIC) is an Indian state-owned insurance group and investment corporation owned by the Government of India. Over 245 insurance companies and provident societies were merged to create the state-owned Life Insurance Corporation of India.</p>
                      <Menu.Item href='https://www.facebook.com/LICIndiaForever'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/licindiaforever/?hl=en'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/LICIndiaForever'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="http://www.licindia.in/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>*/}
                    </Popup>
                    <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gold Sponsor</p>
                    </Grid.Column>
              </Grid.Row>

              <Grid.Row columns={4} style={{marginBottom:'10%'}}>

              <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                      <div style={{height:'175px'}}>
                        <Image size={'medium'} src={Union} centered style={{padddingTop:'10%'}}/>
                      </div>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Union Bank</Popup.Header>
                    {/*<Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      State Bank of India is an Indian multinational, public sector banking and financial services statutory body.SBI provides a range of banking products through its network of branches in India and overseas</p>
                      <Menu.Item href='https://www.facebook.com/StateBankOfIndia'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/theofficialsbi'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/TheOfficialSBI'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://onlinesbi.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>*/}
                    </Popup>
                    <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gold Sponsor</p>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                      trigger={
                      <div>
                      <div style={{height:'175px'}}>
                      <Image size={'medium'} src={LIC} centered />
                      </div>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>LIC</Popup.Header>
                    {/*<Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      Life Insurance Corporation of India (abbreviated as LIC) is an Indian state-owned insurance group and investment corporation owned by the Government of India. Over 245 insurance companies and provident societies were merged to create the state-owned Life Insurance Corporation of India.</p>
                      <Menu.Item href='https://www.facebook.com/LICIndiaForever'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/licindiaforever/?hl=en'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/LICIndiaForever'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="http://www.licindia.in/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>*/}
                    </Popup>
                    <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gold Sponsor</p>
                    </Grid.Column>

                  

                    <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                      trigger={
                      <div>
                      <div style={{height:'175px'}}>
                        <Image size={'medium'} src={NTPC} centered/>
                      </div>
                      </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                    >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>NTPC</Popup.Header>
                    {/*<Popup.Content>
                      <div style={{textAlign:'center'}}>
                      <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                      State Bank of India is an Indian multinational, public sector banking and financial services statutory body.SBI provides a range of banking products through its network of branches in India and overseas</p>
                      <Menu.Item href='https://www.facebook.com/StateBankOfIndia'>
                        <Icon name='facebook square' link size='big' style={{color:'black'}} />
                      </Menu.Item>
                      <Menu.Item href='https://www.instagram.com/theofficialsbi'>
                        <Icon name='instagram' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href='https://twitter.com/TheOfficialSBI'>
                        <Icon name='twitter' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      <Menu.Item href="https://onlinesbi.com/">
                        <Icon name='world' size='big' style={{color:'black'}}/>
                      </Menu.Item>
                      </div>
                    </Popup.Content>*/}
                    </Popup>
                    <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gold Sponsor</p>
                  </Grid.Column>
                  
                  </Grid.Row>

              {/*<Container style={{width:'25%',
                        position:'relative',borderRadius:'0px 150px 150px 150px', marginBottom:'5%', marginTop:'10%'}}>
                    <Header style={{color:'#FF3F1A',fontSize:'2.5em',fontFamily:'\'Paytone One\', sans-serif', textAlign:'center', padddingTop:'1%', paddingBottom:'1%'}}>
                        Partners
                    </Header>
                  </Container>*/}
                  

              <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'200px'}}>
                    <Image size={'medium'} src={Foxmula} centered  />
                    </div>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Foxmula</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Industrial & Training Partner</p>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'200px'}}>
                    <Image size={'medium'} src={Knowello} centered style={{paddingTop:'25%'}}/>
                    </div>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Knowello</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    With the vision to deliver unparalleled and quality fashion footwear, to adorn feet across the country, CENTRO, within a decade of its inception, has established itself as one of the largest retail, distribution, and franchising companies in South India.</p>
                    <Menu.Item href='https://www.facebook.com/centroshoes/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/centroshoesindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/centro_shoes'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.fashioncentro.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Business Development Partner</p>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'200px'}}>
                    <Image size={'medium'} src={FORE} centered />
                    </div>
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Knowledge Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>FORE</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'300px'}}>
                    <Image size={'medium'} src={Yocket} centered style={{paddingTop:'25%'}}/>
                    </div>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Yocket</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Study Abroad Partner</p>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'300px'}}>
                    <Image size={'medium'} src={Celeb8} centered/>
                    </div>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Celebr8</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Veels on 5er are committed to satisfy all your hobby needs. They help you get into the hobby by providing all the details/information you would ever require.
                              They provide complete sales & service for any brand/model RC Nitro Cars, Electric Cars</p>
                    <Menu.Item href='https://www.facebook.com/VeelsOn5er/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="https://www.veelson5er.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Event Partner</p>
                  </Grid.Column>

                  

                </Grid.Row>

                <Container style={{width:'25%',
                        position:'relative',borderRadius:'0px 150px 150px 150px', marginBottom:'5%', marginTop:'10%'}}>
                    <Header style={{color:'#FF3F1A',fontSize:'2.5em',fontFamily:'\'Paytone One\', sans-serif', textAlign:'center', padddingTop:'1%', paddingBottom:'1%'}}>
                        Partners
                    </Header>
              </Container>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>

                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'300px'}}>
                    <Image size={'medium'} src={AM} centered style={{paddingTop:'50%'}}/>
                    </div>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Airmeet</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    With the vision to deliver unparalleled and quality fashion footwear, to adorn feet across the country, CENTRO, within a decade of its inception, has established itself as one of the largest retail, distribution, and franchising companies in South India.</p>
                    <Menu.Item href='https://www.facebook.com/centroshoes/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/centroshoesindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/centro_shoes'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.fashioncentro.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Partner</p>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'300px'}}>
                    <Image size={'medium'} src={ces} centered/>
                    </div>
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Campus Events</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    With the vision to deliver unparalleled and quality fashion footwear, to adorn feet across the country, CENTRO, within a decade of its inception, has established itself as one of the largest retail, distribution, and franchising companies in South India.</p>
                    <Menu.Item href='https://www.facebook.com/centroshoes/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/centroshoesindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/centro_shoes'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.fashioncentro.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'300px'}}>
                    <Image size={'medium'} src={CampusComedyClub} centered style={{paddingTop:'25%'}}/>
                      </div>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Campus Comedy Club</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Partner</p>
                  </Grid.Column>
                  
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>

                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'250px'}}>
                    <Image size={'medium'} src={CodingNinjas} centered />
                    </div>
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Education Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Coding Ninjas</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Veels on 5er are committed to satisfy all your hobby needs. They help you get into the hobby by providing all the details/information you would ever require.
                              They provide complete sales & service for any brand/model RC Nitro Cars, Electric Cars</p>
                    <Menu.Item href='https://www.facebook.com/VeelsOn5er/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    <Menu.Item href="https://www.veelson5er.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'250px'}}>
                    <Image size={'medium'} src={Wiley} centered style={{paddingTop:'25%'}}/>
                    </div>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Wiley</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    India Film Project, since its birth in 2011, has been putting in efforts to build a community of content creators across the varying forms of art. The 50-hour filmmaking challenge is IFP’s cornerstone. Now IFP also extended itself in other forms of art, mainly writing, designing, music and storytelling</p>
                    <Menu.Item href='https://www.facebook.com/indiafilmproject'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/indiafilmproject'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/ifilmproject'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://indiafilmproject.co/campus/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Knowledge Partner</p>
                  </Grid.Column>

                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                      <div style={{height:'250px'}}>
                    <Image size={'medium'} src={coolwinks} centered style={{paddingTop:'50%'}}/>
                    </div>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Coolwinks</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    India Film Project, since its birth in 2011, has been putting in efforts to build a community of content creators across the varying forms of art. The 50-hour filmmaking challenge is IFP’s cornerstone. Now IFP also extended itself in other forms of art, mainly writing, designing, music and storytelling</p>
                    <Menu.Item href='https://www.facebook.com/indiafilmproject'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/indiafilmproject'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/ifilmproject'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://indiafilmproject.co/campus/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Eyewear Partner</p>
                  </Grid.Column>

                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                
                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={internshala} centered  />
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Internshala</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Campus Outreach Partner</p>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={skolar} centered  />
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Skolar</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Growth Partner</p>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={TalkingTimber} centered  />
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Talking Timber</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gifting Partner</p>
                  </Grid.Column>

                  
                  
                  </Grid.Row>

                  <Grid.Row columns={4} style={{marginBottom:'10%'}}>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Indinoir} centered />
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Indinoir</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Gifting Partner</p>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={chromatics} centered />
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Chromatics</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ascend from Harvard Business Review is a digital learning companion for millennials and graduating students, focused on developing soft-skills which can provide an extra edge for balanced career growth.</p>
                    <Menu.Item href='https://www.facebook.com/hbrascend/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/hbrascend/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/hbrascend?lang=en'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://hbrascend.org/home/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={CelebritySchool} centered  />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Celibrity School</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>
                  
                </Grid.Row>

                <Grid.Row columns={4} style={{marginBottom:'10%'}}>

                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={QT} centered  />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Official Literary Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Qwety Thoughts</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Fanclash} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>E-sports Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Fanclash</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ascend from Harvard Business Review is a digital learning companion for millennials and graduating students, focused on developing soft-skills which can provide an extra edge for balanced career growth.</p>
                    <Menu.Item href='https://www.facebook.com/hbrascend/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/hbrascend/?hl=en'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/hbrascend?lang=en'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://hbrascend.org/home/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>
                  

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Vedana} centered  />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Fashion Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Vedana</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>
                  
                  
                  
                </Grid.Row>


                <Grid.Row columns={4} style={{marginBottom:'10%'}}>

                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Kaploths} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Men Fashion Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Kaploths</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    With the vision to deliver unparalleled and quality fashion footwear, to adorn feet across the country, CENTRO, within a decade of its inception, has established itself as one of the largest retail, distribution, and franchising companies in South India.</p>
                    <Menu.Item href='https://www.facebook.com/centroshoes/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/centroshoesindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/centro_shoes'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.fashioncentro.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={GrabOn} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Grab On</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={vishumoney} centered  />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>VishuMoney</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>
                  </Grid.Row>

                  
                <Grid.Row columns={4} style={{marginBottom:'10%'}}>

                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={CodeforCause} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Workshop Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Code for Cause</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    With the vision to deliver unparalleled and quality fashion footwear, to adorn feet across the country, CENTRO, within a decade of its inception, has established itself as one of the largest retail, distribution, and franchising companies in South India.</p>
                    <Menu.Item href='https://www.facebook.com/centroshoes/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/centroshoesindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/centro_shoes'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.fashioncentro.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Techienest} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Workshop Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Techienest</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Eleation} centered  />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Workshop Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Eleation</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>
                  </Grid.Row>

              
                <Container style={{width:'25%',
                        position:'relative',borderRadius:'0px 150px 150px 150px', marginBottom:'5%', marginTop:'10%'}}>
                    <Header style={{color:'#FF3F1A',fontSize:'2.5em',fontFamily:'\'Paytone One\', sans-serif', textAlign:'center', padddingTop:'1%', paddingBottom:'1%'}}>
                        Media Partners
                    </Header>
              </Container>

                  <Grid.Row columns={4} style={{marginBottom:'10%'}}>
                    <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                          trigger={
                            <div>
                              <Image size={'medium'} src={Shubhang} centered  />
                              <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Communications Partner</p>
                            </div>
                          }
                          position='bottom center'
                          style={{borderRadius:'50px'}}
                          hoverable
                          wide = 'very'
                      >
                        <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Shubang Communications</Popup.Header>
                        {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                      </Popup>
                    </Grid.Column>

                    <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                          trigger={
                            <div>
                              <Image size={'medium'} src={HansIndia} centered />
                              <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Media Partner</p>
                            </div>
                          }
                          position='bottom center'
                          style={{borderRadius:'50px'}}
                          hoverable
                          wide = 'very'
                      >
                        <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>The Hans India</Popup.Header>
                        {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                      </Popup>
                    </Grid.Column>

                    <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                      <Popup
                          trigger={
                            <div>
                              <Image size={'medium'} src={Youth_incorporated} centered  />
                              <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Youth Media Partner</p>
                            </div>
                          }
                          position='bottom center'
                          style={{borderRadius:'50px'}}
                          hoverable
                          wide = 'very'
                      >
                        <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Youth Incorporated</Popup.Header>
                        {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                      </Popup>
                    </Grid.Column>

                  </Grid.Row>

              <Grid.Row columns={4} style={{marginBottom:'10%'}}>


                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Summachar} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Media Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Summachar</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={Noticebard} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Media Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>NoticeBard</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    With the vision to deliver unparalleled and quality fashion footwear, to adorn feet across the country, CENTRO, within a decade of its inception, has established itself as one of the largest retail, distribution, and franchising companies in South India.</p>
                    <Menu.Item href='https://www.facebook.com/centroshoes/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/centroshoesindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/centro_shoes'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.fashioncentro.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                  <Popup
                      trigger={
                        <div>
                          <Image size={'medium'} src={FASHION_HERALD} centered />
                          <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Fashion Media Partner</p>
                        </div>
                      }
                      position='bottom center'
                      style={{borderRadius:'50px'}}
                      hoverable
                      wide = 'very'
                  >
                    <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Fashion Herald</Popup.Header>
                    {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    With the vision to deliver unparalleled and quality fashion footwear, to adorn feet across the country, CENTRO, within a decade of its inception, has established itself as one of the largest retail, distribution, and franchising companies in South India.</p>
                    <Menu.Item href='https://www.facebook.com/centroshoes/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/centroshoesindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/centro_shoes'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.fashioncentro.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                </Grid.Column>
                  
                </Grid.Row>


                
                <Grid.Row columns={4} style={{marginBottom:'10%'}}>


                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={DE_DU_Express} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Youth Media Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>DU Express</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Awesong.in is a next generation music platform where the budding artists from all over the world get chance to showcase their talent and redefine the original songs with their own music creations. Awesong is India's first platform to redefine the music and to bring and nurture music talent.</p>
                    <Menu.Item href='https://www.facebook.com/awesong.in/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/awesong.in'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/awesongmusic'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://awesong.in//">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>
                  
                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                    trigger={
                    <div>
                    <Image size={'medium'} src={DU_Beat} centered />
                      <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Media Partner</p>
                    </div>
                    }
                    position='bottom center'
                    style={{borderRadius:'50px'}}
                    hoverable
                    wide = 'very'
                  >
                  <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>DU Beat</Popup.Header>
                  {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    With the vision to deliver unparalleled and quality fashion footwear, to adorn feet across the country, CENTRO, within a decade of its inception, has established itself as one of the largest retail, distribution, and franchising companies in South India.</p>
                    <Menu.Item href='https://www.facebook.com/centroshoes/'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/centroshoesindia/'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/centro_shoes'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.fashioncentro.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                  </Popup>
                  </Grid.Column>

                  <Grid.Column style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto'}}>
                    <Popup
                        trigger={
                          <div>
                            <Image size={'medium'} src={Esports} centered  />
                            <p style={{textAlign:'center', fontSize:'1.5em', marginTop:'10%'}}>Online Publicity partner</p>
                          </div>
                        }
                        position='bottom center'
                        style={{borderRadius:'50px'}}
                        hoverable
                        wide = 'very'
                    >
                      <Popup.Header style={{textAlign:'center', fontSize:'2em'}}>Esports India</Popup.Header>
                      {/*<Popup.Content>
                    <div style={{textAlign:'center'}}>
                    <p style={{fontSize:'1.25em', paddingTop:'5%', paddingBottom:'5%', paddingLeft:'15%', paddingRight:'15%'}}>
                    Ola is India’s largest mobility platform and one of the world’s largest ride-hailing companies, serving 250+ cities. The Ola app offers mobility solutions by connecting customers to drivers and a wide range of vehicles, enabling convenience and transparency for hundreds of millions of consumers and over 1.5 million driver-partners.</p>
                    <Menu.Item href='https://www.facebook.com/Olacabs'>
                      <Icon name='facebook square' link size='big' style={{color:'black'}} />
                    </Menu.Item>
                    <Menu.Item href='https://www.instagram.com/olacabs'>
                      <Icon name='instagram' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href='https://twitter.com/Olacabs'>
                      <Icon name='twitter' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    <Menu.Item href="https://www.olacabs.com/">
                      <Icon name='world' size='big' style={{color:'black'}}/>
                    </Menu.Item>
                    </div>
                  </Popup.Content>*/}
                    </Popup>
                  </Grid.Column>
                </Grid.Row>

                {/*<Grid.Row columns={4} style={{marginBottom:'10%'}}>*/}

                {/*</Grid.Row>*/}

              </Grid>
              <Grid stackable style={{paddingBottom:'15%', paddingRight:'10%', paddingLeft:'10%', paddingTop:'10%'}}>
              <Grid.Row columns={1} style={{paddingBottom:'5%'}}>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2.5em'}}>CONTACT US</p>
                    <hr style={{color:'black', width:'10%', marginTop:'-2%'}}></hr>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={1} style={{paddingBottom:'5%'}}>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Ashutosh Tiwari</p>
                    <p style={{fontSize:'1.35em'}}>70676 54276</p>
                    <p style={{fontSize:'1.35em'}}>ashutosh.t@elan.org.in</p>
                  </Grid.Column>
                </Grid.Row>
              <Grid.Row columns={4} style={{paddingBottom:'5%'}}>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                  <p style={{fontSize:'2em'}}>Aahan Jain</p>
                  <p style={{fontSize:'1.35em'}}>8008495801</p>
                  <p style={{fontSize:'1.35em'}}>aahan.j@elan.org.in</p>
                  </Grid.Column>

                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Chaitanya Varun</p>
                    <p style={{fontSize:'1.35em'}}>709507594</p>
                    <p style={{fontSize:'1.35em'}}>chaitanya.v@elan.org.in</p>
                  </Grid.Column>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Chirag Jain</p>
                    <p style={{fontSize:'1.35em'}}>9326168076</p>
                    <p style={{fontSize:'1.35em'}}>chirag.j@elan.org.in</p>
                  </Grid.Column>
                </Grid.Row>
              <Grid.Row columns={4}>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Prakhar Pragya</p>
                    <p style={{fontSize:'1.35em'}}>7549136119</p>
                    <p style={{fontSize:'1.35em'}}>prakhar.p@elan.org.in</p>
                  </Grid.Column>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Sachi Kavitake</p>
                    <p style={{fontSize:'1.35em'}}>9511631183</p>
                    <p style={{fontSize:'1.35em'}}>sachi.k@elan.org.in</p>
                  </Grid.Column>
                  <Grid.Column  style={{marginRight:'auto', marginLeft:'auto', marginBottom:'auto', marginTop:'auto', textAlign:'center', fontFamily: '\'Exo\', sans-serif'}}>
                    <p style={{fontSize:'2em'}}>Sohith Kumar</p>
                    <p style={{fontSize:'1.35em'}}>9511631183</p>
                    <p style={{fontSize:'1.35em'}}>sohith.k@elan.org.in</p>
                  </Grid.Column>
                </Grid.Row>
              </Grid></div>) : null}

        {/*order: technological Partner: Arcesium , Gold Sponsors: SBI, LIC and Union , Partners: Foxmula, nuello, Yocket, celebrate, fanclash, whily; Media Partner: */}
        {/*2019: Title Sponsor: cyient; SBI, LIC, Canara; ColorsofYouth, BingoComedyAdda; ola, xebronics, gameetronics; 37: partners; media deals below */}


          {this.state.currentYear === 2019 ?
              (<div></div>) : null}

          {this.state.currentYear === 2018 ?
              (<div></div>) : null}
    </>);
};
    
}

export default Sponsors;









    